const Impressum = () => {
  return (
    <div>
      <div class="text-center">
        <h2>Impressum</h2>
        <br />
        <h3>Ev. Schulstiftung in der EKBO</h3>
        <h4>Protestantisch – Mutig – Weltoffen</h4>
        <p>Evangelische Schulstiftung in der EKBO</p>
        <p>– Kirchliche Stiftung öffentlichen Rechts –</p>
        <p></p>
        <p>Georgenkirchstraße 69</p>
        <p>10249 Berlin</p>
        <p>Deutschland</p>
        <br />
        <p>Vertretungsberechtigte/ Vorstand</p>
        <p>Vorstandsvorsitzender Pädagogischer Vorstand: Frank Olie</p>
        <p>Kaufmännischer Vorstand: Christina Lier</p>
        <br />
        <p>Kontakt</p>
        <p>Telefon Sekretariat: 030 24344455</p>
        <p>E-Mail: info@schulstiftung-ekbo.de</p>
        <p>E-Mail: redaktion@schulstiftung-ekbo.de</p>
        <br />
        <p>Aufsichtsbehörde</p>
        <p>Konsistorium der Ev. Kirche Berlin-Brandenburg-schlesische Oberlausitz vertreten durch die Konsistorialpräsidentin Dr. Viola Vogel</p>
        <br />
        <p>Technische Umsetzung und Betreuung</p>
        <p >
          <a href="https://apizentrum.com" target="_blank" rel="noreferrer" style={{color:"inherit"}}>
            Dietmar Schlabertz (apizentrum.com)
          </a>
        </p>
      </div>
    </div>
  )
}
export default Impressum
